// eslint-disable-next-line import/no-unresolved
import brand from '@brand/brand.js';
import { Trans, useTranslation } from 'react-i18next';
import { BrandedLayout } from '../components/layouts/branded-layout';
import { cleanPhone } from '../utils/phone';

export function InviteLocked() {
  const { t } = useTranslation('page.invite-locked');

  return (
    <BrandedLayout>
      <h1 className="title text-error-500">{t('title')}</h1>

      <Trans
        i18nKey="text"
        ns="page.invite-locked"
        values={{ phone: brand.phone }}
        components={{
          p: <p />,
          br: <br />,
          strong: <strong className="font-semibold" />,
          a: <a href={`tel:${cleanPhone(brand.phone)}`} />,
        }}
      />
    </BrandedLayout>
  );
}
